import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Mineralisation } from 'src/app/bo/geology/mineralisation';
import { ProprieteAffichee } from 'src/app/bo/proprieteAffichee';
import { FonctionsService } from 'src/app/services/fonctions-partagees.service';
import { HttpService } from 'src/app/services/http.service';
import { UtilisateurService } from 'src/app/services/utilisateur.service';

@Component({
  selector: 'app-mineralisation-gui',
  templateUrl: './mineralisation-gui.component.html',
  styleUrls: ['./mineralisation-gui.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule]
})
export class MineralisationGuiComponent implements OnInit {
  @Input() currentRegionId:number = undefined;
  @Input() isAdminOrResReg = false;
  table_width:number[] = [8,39,39,6,6];

  showErrorModif = false;
  showErrorNew = false;

  tabMineralisations: Mineralisation[] = [];
  selectedMineralisation: Mineralisation = new Mineralisation();
  oldMineralisation: Mineralisation = new Mineralisation();

  newMineralisation: Mineralisation = new Mineralisation();
  proprietesAffichees: ProprieteAffichee[] = [];

  isModifiable = -1;
  lastToucheIndex = -1;
  isFooterFocus:boolean;



  constructor(
     private readonly http: HttpService,
     public utilService: UtilisateurService,
     private readonly fonctionsService: FonctionsService
     ) {
       this.proprietesAffichees = new Mineralisation().getProprietesAffichees();
    }


  

  ngOnInit(): void {
    this.getMineralisationsByRegionId();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes['currentRegionId']){
      this.getMineralisationsByRegionId();
    }
  }


  protected selectMineralisation(mineralisation: Mineralisation, index:number, e:any){
    if(this.selectedMineralisation.id === mineralisation.id) return;

    if(this.lastToucheIndex > -1 && this.oldMineralisation.id > 0 ){
      this.tabMineralisations[this.lastToucheIndex] = this.oldMineralisation;

      // this.translate.get('ERRORS_MESSAGE.NO_ITEM_SAVED').subscribe(trad => {
      //   this.fonctionsService.launch_toast(false, false, trad);
      // });

    }

    this.lastToucheIndex = index;
    this.oldMineralisation = Object.assign({}, mineralisation);

    this.selectedMineralisation = Object.assign({}, mineralisation)
    this.isModifiable = index;
    this.clearNew();
  }

  protected clearNew(){
    this.newMineralisation = new Mineralisation();
    this.isFooterFocus = false;

  }
  protected clearSelected(){
    this.selectedMineralisation = new Mineralisation();
  }

  protected newMineralisationChange(){
    this.selectedMineralisation = new Mineralisation();
    this.isModifiable = -1;
    this.isFooterFocus = true;
  }

  protected onFocusOutEvent(){
    this.isFooterFocus = false;
  }

  private getMineralisationsByRegionId(){
    if (this.currentRegionId == undefined){
      this.currentRegionId = this.utilService.currentRegionForSetupRegion.regionId;
    }
    this.fonctionsService.loading_screen(true);

    const url = "Geology/GetAllMineralisationsByRegionId/" + this.currentRegionId;

    this.http.get<Mineralisation[]>(url).subscribe({
     next: result =>{
      this.tabMineralisations = result;
    } ,
    error: (error: HttpErrorResponse) => {
      if(error.status === 401 || error.status === 403){
        console.log(error.error);
        
      }
      this.fonctionsService.launch_toast(false);
      this.fonctionsService.loading_screen(false);
    },
    complete:() => {
       this.fonctionsService.loading_screen(false);
     }
   })
  }


  protected createMineralisation(){
    if(this.newMineralisation.name === '' || this.newMineralisation.shortName === ''){
        this.showErrorNew = true;
        setTimeout(() => {
        this.showErrorNew = false;
      }, 1500);
      return;
    }

    this.fonctionsService.loading_screen(true);
    this.newMineralisation.regionId = this.currentRegionId;
    const url = "Geology/CreateMineralisation";
    this.http.post(url, this.newMineralisation).subscribe({
     next: result =>{
      this.clearNew();
      this.clearSelected();
      this.getMineralisationsByRegionId();
      this.fonctionsService.launch_toast(true);
      this.fonctionsService.loading_screen(false);
     } ,
     error: (error: HttpErrorResponse) => {
      if(error.status === 401 || error.status === 403){
    console.log(error.error);
      }
      this.fonctionsService.launch_toast(false);
      this.fonctionsService.loading_screen(false);
     },
     complete:() => {
      this.fonctionsService.loading_screen(false);
     }
   })
  }

  protected update(m:Mineralisation, index:number){
    if(m.name === '' || m.shortName === ''){
      this.showErrorModif = true;
      setTimeout(() => {
      this.showErrorModif = false;
    }, 1500);
    return;
  }

      this.updateApi(this.tabMineralisations[index]).subscribe({
        next: result =>{
          this.clearNew();
          this.clearSelected();
          this.oldMineralisation = new Mineralisation();
          this.lastToucheIndex = -1;
          this.isModifiable = -1;
          this.fonctionsService.loading_screen(false);
          this.fonctionsService.launch_toast(true);
        } ,
        error: (error: HttpErrorResponse) => {
          if(error.status === 401 || error.status === 403){
        console.log(error.error);
          }
          this.fonctionsService.launch_toast(false);
          this.fonctionsService.loading_screen(false);
        },
        complete:() => {
          this.fonctionsService.loading_screen(false);
        }
      })
  }

  protected delete(selectedMineralisation:Mineralisation){
    selectedMineralisation.regionId = 0;
      this.updateApi(selectedMineralisation).subscribe({
        next: result =>{
         this.clearNew();
         this.clearSelected();
         this.oldMineralisation = new Mineralisation();
         this.lastToucheIndex = -1;
         this.isModifiable = -1;
         this.fonctionsService.loading_screen(false);
         this.tabMineralisations = this.tabMineralisations.filter((item) => item.id !== selectedMineralisation.id);
         this.fonctionsService.launch_toast(true);
        } ,
        error: (error: HttpErrorResponse) => {
         if(error.status === 401 || error.status === 403){
       console.log(error.error);
         }
         this.fonctionsService.launch_toast(false);
         this.fonctionsService.loading_screen(false);
        },
        complete:() => {
         this.fonctionsService.loading_screen(false);
        }
      })
  }

  private updateApi(selectedMineralisation:Mineralisation){
    this.fonctionsService.loading_screen(true);
    const url = "Geology/UpdateMineralisation";
    return this.http.put(url, selectedMineralisation)
  }

}
